import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./blogs.css";
import BlogsDetails from "./blogdetails";
import CustomButton from "../component/button/button";
import { Helmet } from "react-helmet-async";

function Blogs() {
  const handleClick = (paths) => {
    window.location.href = `/blogs/${paths}`;
  };

  return (
    <>
    <Helmet>
        <title>Healthy Baking Blog – Natural Cakes Chennai</title>
        <meta
          name="description"
          content="Read tips on natural ingredient cakes, no-maida baking, healthy snacks & preservative-free desserts from Chennai’s healthy bakery."
        />
        <link rel="canonical" href="https://wheatbakes.com/blogs" />

      </Helmet>
    
    <Container className="mt-4">
      
      <div className="p-3" data-aos="fade-up">
        <p className="text-align-center brown-text-color text-bold-600">
          Blogs
        </p>
        <h1 className="text-align-center text-bold-600">
          Where every slice comes with a story.
        </h1>
      </div>
      {/* <div className="p-5">
        <h2 className="text-align-center brown-text-color">Our blog is baking in the oven — launching soon, stay tuned!</h2>
      </div> */}
      <Row>
        {BlogsDetails && BlogsDetails.map((blog) => (
          <Col md={4} sm={6} xs={12} key={blog.id} className="mb-4">
            <Card className="h-100 shadow-sm">
              <Card.Img variant="top" src={blog.image} />
              <Card.Body>
                <Card.Title className="text-bolder brown-text-color text-bold-600">{blog.title}</Card.Title>
                <Card.Text>{blog.description}</Card.Text>
                <Card.Text>Published On : {blog.published}</Card.Text>
                <CustomButton
                  buttonType={2}
                  text={"Read More"}
                  size={"md"}
                  path={blog.path}
                  onClick={() => handleClick(blog.path)}
                  require={true}
                />
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
    </>
  );
}

export default Blogs;
